<template>
  <div class="haizol-layout">
    <div class="headerText" v-if="$store.state.userInfo.loginAsManagerId>0 && $route.name!=='boot-page-preview-contract'">你已临时获得授权登录账号，请遵守保密条例！</div>
    <!-- Header头部 -->
    <Header v-show="$route.name!=='boot-page-preview-contract'"/>
    <div :class="$store.state.userInfo.loginAsManagerId>0?'haizol-layout-contentH':'haizol-layout-content'"  :style="{'height':$route.name==='boot-page-preview-contract' ? '100vh':''}">
      <!-- Nav左侧菜单,matchRouter 用于匹配是否是甄云专区layout页面路由 -->
      <template v-if="matchRouter">
        <Nav v-show="!this.$route.meta.noNav" />
        <Main/>
      </template>
      <template v-else>
        <zhenyunNav></zhenyunNav>
        <zhenyunMain></zhenyunMain>
      </template>
     
      <!-- 外站跳转 -->
      <linkedin />
    </div>
  </div>
</template>

<script>
import Header from '@/components/layout/header.vue';
import Nav from '@/components/layout/nav.vue';
import Main from '@/components/layout/main.vue';
import linkedin from '@/components/linkedin'
import { mapState,mapActions } from 'vuex'
import zhenyunNav from '@/components/zhenyunLayout/nav.vue'
import zhenyunMain from '@/components/zhenyunLayout/main.vue'
export default {
  data(){
    return {
   
    }
  },
  components: {
    Header,
    Nav,
    Main,
    linkedin,
    zhenyunNav,
    zhenyunMain
  },
  methods: {
    ...mapActions('permissionVerification', ['requestAccessData']),
  },
  created() {
    // this.requestAccessData()
  },
  mounted(){
  },
  computed:{
    matchRouter(){
      const firstPathSegment = this.$route.path.split('/')[1];
      // 判断是否为partner路由，如果不是则返回true，否则返回false。这样可以排除掉所有以/partner开头的路径
      return firstPathSegment !== 'partner' && !this.$route.path.startsWith('/partner');
    }
  }
  
}
</script>

<style lang="scss" scoped>
.haizol-layout {
  // min-width: 1438px;
  &-content {
    height: calc(100vh - 72px);
    background: #F5F7FA;
    display: flex;
  }
  &-contentH {
    height: calc(100vh - 118px);
    background: #F5F7FA;
    display: flex;
  }
}
.headerText{
  height: 46px;
  background:#EAF3FD ;
  color: #6785BD;
  text-align: center;
  line-height: 46px;
}
</style>